import {
  type CheckboxChangeEventType,
  type DropDownResult,
  DynamicFormRequiredType,
  type DynamicFormSettings,
} from '@myosh/odin-components';
import i18next from '../../../i18n';
import HfDropDownMultiSelect from '../../fields/custom-drop-downs/hf-drop-down-multi-select.component';
import HfDropDown from '../../fields/custom-drop-downs/hf-drop-down.component';
import { formField } from '../form-builder-utils';
import { dataSettings } from './common.util';

// Common field details form settings
export const fieldTypeDropdownOptions = Object.keys(formField).map((key) => {
  return {
    text: formField[key].text,
    value: key,
  };
});

export const sortedFieldTypeDropdownOptions = [...fieldTypeDropdownOptions].sort((a, b) =>
  a.text.localeCompare(b.text)
);

export const DEFAULT_FIELD_TYPE_OPTION: DropDownResult = { value: 'TEXTFIELD', text: 'TEXTFIELD' };

export const CommonFieldDetailsFormSettings: DynamicFormSettings = {
  id: 'CommonFieldDetailsSettingsGroup',
  caption: '',
  fields: [
    {
      id: 'fieldCaption',
      fieldType: 'TEXTFIELD',
      fieldName: 'fieldCaption',
      caption: i18next.t('name', 'Name'),
      required: DynamicFormRequiredType.True,
      position: 5,
      permissions: { edit: true, read: true },
    },
    {
      id: 'help',
      fieldType: 'RICHTEXTAREA',
      fieldName: 'help',
      caption: i18next.t('help', 'Help'),
      required: DynamicFormRequiredType.False,
      position: 10,
      helpMessage: '(optional) Add help or instructions for this field. This will be displayed in hover text.',
    },
    {
      id: 'hint',
      fieldType: 'TEXTAREA',
      fieldName: 'hint',
      caption: i18next.t('hint', 'Hint'),
      required: DynamicFormRequiredType.False,
      dynamicProperties: {
        rows: 5,
      },
      position: 15,
    },
    {
      id: 'fieldType',
      fieldType: 'COMBOBOX',
      fieldName: 'fieldType',
      caption: i18next.t('type', 'Type'),
      dataSettings: dataSettings,
      required: DynamicFormRequiredType.True,
      permissions: { edit: true, read: true },
      dynamicProperties: {
        allowClear: false,
      },
      position: 20,
    },
    {
      id: 'required',
      fieldType: 'CHECKBOX',
      fieldName: 'required',
      caption: i18next.t('mandatory', 'Mandatory'),
      required: DynamicFormRequiredType.False,
      position: 25,
    },
    {
      id: 'lockDown',
      fieldType: 'CHECKBOX',
      fieldName: 'lockDown',
      caption: i18next.t('lock-down', 'Lock Down'),
      required: DynamicFormRequiredType.False,
      position: 30,
    },
  ],
  fieldValueConverters: {
    CHECKBOX: (value) => {
      const convertedValue = value as unknown as CheckboxChangeEventType;
      return convertedValue.checked;
    },
    RICHTEXTAREA: (value) => {
      return value === '<p></p>' ? '' : value;
    },
  },
  customFieldComponents: {
    COMBOBOX: HfDropDown,
    DROPDOWNMULTISELECT: HfDropDownMultiSelect,
  },
};
